export default "__VITE_ASSET__oweTtaLP__"